import { Box, FormControl, Icons, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import BookingRequestContinueButton from "components/booking-request/booking-request-continue-button";
import { SelectDate } from "components/selection-components/select-date/select-date";
import SelectionHeader from "components/selection-components/selection-header";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function BookingRequestDate() {
    const { t } = useTranslation();
    const { setDate } = useBookingActionsContext();
    const { date } = useBookingStateContext();

    const [localDate, setlocalDate] = useState(date);
    const handleContinue = () => {
        if (!localDate) return;
        setDate?.(localDate?.toDate());
    };

    const handleDateChange = (date: Date) => {
        setlocalDate(date ? moment(date) : undefined);
    };
    const footerHeight = "104px";
    return (
        <FormControl>
            <SelectionHeader text={t("bookingRequest.date.title")} icon={Icons.Date} />
            <Box
                mb={{
                    base: footerHeight,
                    md: ThemeSpaceVariable.Large,
                }}
            >
                <SelectDate
                    onChange={handleDateChange}
                    date={localDate?.toDate()}
                    bookingRequestMode
                />
            </Box>
            <BookingRequestContinueButton handleContinue={handleContinue} disabled={!localDate} />
        </FormControl>
    );
}
